import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, Tab, Tabs, Paper } from "@mui/material";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import TopNavBar from "../../components/TopNavBar/DefaultNavBar";
import FileUpload from "./components/FileUpload";
import TextEntry from "./components/TextEntry";
import DocumentProcessing from "./components/DocumentProcessing";
import { useCimbeo } from "../../context";
import { v4 as uuidv4 } from 'uuid';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`artifact-tabpanel-${index}`}
      aria-labelledby={`artifact-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

function ArtifactIngestion() {
  const location = useLocation();
  const [tabValue, setTabValue] = useState(() => location.state?.activeTab || 0);
  const [artifactType, setArtifactType] = useState('requirements');
  const [selectedProject, setSelectedProject] = useState('');
  const { ingestedDocuments, setIngestedDocuments, projects, setProjects } = useCimbeo();

  // Add effect to update tab when location state changes
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setTabValue(location.state.activeTab);
    }
  }, [location.state]);

  const handleTabChange = (_, index) => {
    setTabValue(index);
  };

  const handleArtifactTypeChange = (event) => {
    setArtifactType(event.target.value);
  };

  const handleProjectSelect = (projectName) => {
    setSelectedProject(projectName);
  };

  const handleDocumentIngestion = (documentName) => {
    if (!selectedProject) {
      alert('Please select a project before ingesting documents');
      return;
    }

    const newDocument = {
      id: uuidv4(),
      name: documentName,
      type: artifactType,
      status: 'processing',
      completedSteps: [],
      projectName: selectedProject,
      timestamp: new Date().toISOString(),
      uploadedBy: "Brian Sisco",
      stepStartTime: Date.now()
    };

    // Update CIMBEO context with new document
    setIngestedDocuments(prev => [...prev, newDocument]);
    
    // Update the project's documents array
    setProjects(prev => prev.map(project => {
      if (project.title === selectedProject) {
        return {
          ...project,
          documents: [...project.documents, newDocument.id]
        };
      }
      return project;
    }));

    setTabValue(2); // Switch to Processing tab
  };

  return (
    <DashboardLayout>
      <TopNavBar />
      <Box sx={{ width: '100%', mt: 3 }}>
        <Paper sx={{ 
            width: '100%',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            <Tab label="File Upload" />
            <Tab label="Text Entry" />
            <Tab label="Processing" />
          </Tabs>
        </Paper>

        <TabPanel value={tabValue} index={0}>
          <FileUpload 
            artifactType={artifactType} 
            onArtifactTypeChange={handleArtifactTypeChange}
            onDocumentIngestion={handleDocumentIngestion}
            selectedProject={selectedProject}
            onProjectSelect={handleProjectSelect}
          />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <TextEntry 
            artifactType={artifactType} 
            onArtifactTypeChange={handleArtifactTypeChange}
            onDocumentIngestion={handleDocumentIngestion}
            selectedProject={selectedProject}
            onProjectSelect={handleProjectSelect}
          />
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <DocumentProcessing />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
}

export default ArtifactIngestion;
